 export default function prepaymentCalculator(propPayments, sum) {
  const payments = propPayments.map((item) => ({ ...item, calculated: 0 }));
  
  let remainingSum = sum;
  const paymentsByOrder = payments.reduce((acc, obj) => {
    acc[obj.order] = obj;
    return acc;
  }, []);

  function subtractPayment(startI) {
    for (let i = startI; i < paymentsByOrder.length; i += 1) {
      if (remainingSum <= paymentsByOrder[i].summa) {
        paymentsByOrder[i].calculated = remainingSum;
        remainingSum = 0;
        return;
      }
      remainingSum -= paymentsByOrder[i].summa;
      paymentsByOrder[i].calculated = paymentsByOrder[i].summa;
    }
  }
  subtractPayment(1);
  return payments;
}